import { render, staticRenderFns } from "./PathwayView.vue?vue&type=template&id=31ef8954&scoped=true"
import script from "./PathwayView.vue?vue&type=script&lang=js"
export * from "./PathwayView.vue?vue&type=script&lang=js"
import style0 from "./PathwayView.vue?vue&type=style&index=0&id=31ef8954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef8954",
  null
  
)

export default component.exports